function matchSlideHeights() {
  const $slider = $('.slick-slider');
  const $first = $slider.find('.slick-slide[data-slick-index="0"]');
  const $second = $slider.find('.slick-slide[data-slick-index="1"]');

  if ($first.length && $second.length) {
    const secondHeight = $second.outerHeight();
    $first.css('height', secondHeight);
  }
}

// Run after Slick initializes and after each resize/slide
$('.slick-slider').on('setPosition afterChange', function() {
  matchSlideHeights();
});

$('.slick-slider').on('init', function() {
  matchSlideHeights();
});


$('.slick-slider').slick({
  dots: false,
  arrows: false,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll:1,
  variableWidth: true,
   responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        dots: true,
      }
    }
  ]
});